// ContactList: component for showing a list of contacts,
// such as a list of group members in a group chat.
import React from 'react';
import { defineMessages, injectIntl } from 'react-intl';

import { Drafty, Tinode } from '../tinode/tinode';
import { Topic } from '../tinode/topic.js'

import Contact from './contact.jsx';
import ContactAction from './contact-action.jsx';

import { makeImageUrl } from '../lib/blob-helpers.js';

import { MESSAGE_PREVIEW_LENGTH } from '../config.js';
import Contact404 from './404/contact-404.jsx';
import  { CONTACT_LIST_SHOW_MODE } from '../tinode/constants.js'

const messages = defineMessages({
  badge_you: {
    id: 'badge_you',
    defaultMessage: 'you',
    description: 'Badge for indicating the current user'
  },
  badge_owner: {
    id: 'badge_owner',
    defaultMessage: 'owner',
    description: 'Badge for indicating the owner'
  },
  hidden_topic: {
    id: 'hidden_topic',
    defaultMessage: 'Hidden conversation',
    description: 'Hidden conversation'
  }
});

class ContactList extends React.Component {
  render() {
    const { formatMessage } = this.props.intl;
    const showCheckmark = Array.isArray(this.props.topicSelected);
    const contactNodes = [];
    let contactsCount = 0;
    let page404 = false;
    if (this.props.contacts && this.props.contacts.length > 0) {
      this.props.contacts.map((c) => {
        if (c.action) {
          // Action item
          contactNodes.push(
            <ContactAction
              title={c.title} action={c.action} values={c.values}
              key={c.action}
              onAction={this.props.onAction}
            />);
        } else {
          // Normal contact
          const key = this.props.showMode ? c.user : (c.topic || c.user);
          // If filter function is provided, filter out the items
          // which don't satisfy the condition.
          if (this.props.filterFunc && this.props.filter) {
            const filterOn = [key];
            if (c.private && c.private.comment) {
              filterOn.push(('' + c.private.comment).toLowerCase());
            }
            if (c.public && c.public.fn) {
              filterOn.push(('' + c.public.fn).toLowerCase());
            }
            if (!this.props.filterFunc(this.props.filter, filterOn)) {
              return;
            }
          }

          const isChannel = Tinode.isChannelTopicName(key);
          const isGroup = !isChannel && Tinode.isGroupTopicName(key);
          const selected = showCheckmark ?
            (this.props.topicSelected.indexOf(key) > -1) :
            (this.props.topicSelected === key);
          const badges = [];
          if (this.props.showMode) {
            if (key == this.props.myUserId) {
              badges.push({ name: formatMessage(messages.badge_you), color: 'green' });
            }
            if (c.acs && c.acs.isOwner()) {
              badges.push({ name: formatMessage(messages.badge_owner), color: 'blue' });
            }
          }

          // const comment = Array.isArray(c.private) ?
          //   c.private.join(',') : (c.private ? c.private.comment : null);
          let comment = c.public ? c.public.fn : ''
          if(c && c.latestMessage && !c.latestMessage()){
            if(c && c.public && c.public.cmsisdn && c.public.cmsisdn !== ''){
              comment = c.public.cmsisdn
            }
          }
          let preview;
          let forwarded;
          let previewIsResponse;
          let deliveryStatus;
          let msg = null
          let isFormattedPreview = false
          if (!!this.props.showContactMode) {
            
            switch(this.props.showContactMode) {
              case CONTACT_LIST_SHOW_MODE.PHONE_NUMBER: {
                isFormattedPreview = true
                preview = c.public.cmsisdn || Topic.getThreadId(c.topic)
                comment = preview
                break
              }
            }
          }
          if (!isFormattedPreview && !this.props.showMode && c.latestMessage) {
            msg = c.latestMessage();
            
            if (msg) {
              forwarded = msg.head ? msg.head.forwarded : null;
              deliveryStatus = msg._status || c.msgStatus(msg, true);
              previewIsResponse = msg.from != this.props.myUserId;
              if (msg.content) {
                preview = typeof msg.content == 'string' ?
                  msg.content.substr(0, MESSAGE_PREVIEW_LENGTH) :
                  Drafty.preview(msg.content, MESSAGE_PREVIEW_LENGTH);
              }
            }
          }
          const checkMarkContact = !!(this.props.listCheckmakrContacts && this.props.listCheckmakrContacts.find(item => item.topic === key));
          const showAcs = this.props.showAcs !== undefined ? this.props.showAcs : true;
          const isPin = !!c.isPin
          const isHide = !!c.isHide
          const isSearchHidePassword = !!c.isSearchHidePassword
          const searchExact = !!c.searchExact
          if (!this.props.isHideTopic || !isHide || isSearchHidePassword || searchExact) {
            if (isHide) {
              preview = formatMessage(messages.hidden_topic)
            }
            contactNodes.push(
              <Contact
                lastMsgTime={c.touched}
                lastMsg={msg}
                showLastMsgTime={this.props.showLastMsgTime || false}
                tinode={this.props.tinode}
                title={c.private && c.private.comment ? c.private.comment : (c.public ? c.public.fn : '')}
                topic={c}
                avatar={makeImageUrl(c.public ? c.public.photo : null)}
                comment={comment}
                preview={preview}
                previewIsResponse={previewIsResponse}
                forwarded={forwarded}
                received={deliveryStatus}
                unread={this.props.showUnread ? c.unread : 0}
                now={c.online && this.props.connected}
                acs={showAcs ? c.acs : false}
                showMode={this.props.showMode}
                showBadges={this.props.showBadges}
                badges={badges}
                showCheckmark={showCheckmark}
                selected={selected}
                showOnline={this.props.showOnline && !isChannel}
                isChannel={isChannel}
                isGroup={isGroup}
                isPin={isPin}
                isShowPin={this.props.isShowPin || false}
                showContextMenu={this.props.showContextMenu}
                isVerified={c.trusted && c.trusted.verified}
                isStaff={c.trusted && c.trusted.staff}
                isDangerous={c.trusted && c.trusted.danger}
                deleted={c._deleted}
                onSelected={this.props.onTopicSelected}
                item={key}
                index={contactNodes.length}
                key={key}
                showCheckmarkContact={this.props.showCheckmarkContact}
                checkMarkContact={checkMarkContact}
                small={this.props.small}
                topicName={c.name}
                showButtonForward={this.props.showButtonForward}
                handleTopicSelected={this.props.handleTopicSelected}
                isShowTyping={this.props.isShowTyping}
                messageOld={(!selected && !!c.getDraft) ? c.getDraft() : undefined}
                focusTag={this.props.focusTag}
                focusId={this.props.focusId}
                onlyShowComment={this.props.onlyShowComment}
              />
            );
            contactsCount++;
          }
        }
      }, this);
    } else {
      page404 = true;
      contactNodes.push(
        <div className='not-found-contact' key={0} >
          <Contact404 iconEmpty={this.props.iconEmpty} />
        </div>
      )
    }

    return (
      <div className={this.props.noScroll ? null : "scrollable-panel"}>
        {/* {contactsCount == 0 ?
          <div className="center-medium-text"
            dangerouslySetInnerHTML={{ __html: this.props.emptyListMessage }} />
          :
          null
        } */}
        {contactNodes.length > 0 ?
          <ul className={`contact-box ${page404 && 'contact-404'}`}>
            {contactNodes}
          </ul>
          :
          null
        }
      </div>
    );
  }
};

export default injectIntl(ContactList);
